module.exports = "/assets/467573ad3cde735cc5678e1582ae26fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XM.png
// module id = 2001
// module chunks = 0